import React from 'react';
import moment from 'moment-with-locales-es6';

export const OfertaNoVigente2 = React.memo((data) => {

	//console.log('dataExpirada: ', data);

	let fechaVigencia = data.fechaVigencia;
	moment.locale('es');
	fechaVigencia = moment(fechaVigencia).format('LL');

	return (
		<div className="promo expirada">

			<div className="titulo">Esta oferta ya expiró</div>

			<p>Su vigencia fue hasta {fechaVigencia}. Mantente alerta de los mensajes de promoción que UNEFON tiene para ti</p>

			

		</div>
	)
})
